export const SLIDESHOW_REGENERATION_TRESHOLD_MINS = 15;
